import { PlaybookBot } from './playbook-bot';
export default PlaybookBot;
